import { Box } from '@material-ui/core';
import { ArticleTypeExternal, formatDateReadable, formatMoney } from '@nemuru-eng/js-api-client';

import { DialogHeader } from '@/components/shared/components/ItemDetail/components/shared/DialogHeader';
import { ItemDetailProps } from '@/components/shared/components/ItemDetail/types/ItemDetailProps';
import { StatusTag } from '@/components/shared/components/StatusTag/StatusTag';
import { useTranslation } from '@/components/shared/hooks/useTranslation';
import { Font } from '@/components/shared/components/Font';
import { ReadOnlyDataRow } from '@/components/shared/components/ReadOnlyDataRow';
import { Text } from '@/components/shared/components/Text';

export const Automobile = ({ itemDetail, itemStatus, currency }: ItemDetailProps) => {
  const { getTextIdTranslation } = useTranslation();
  if (itemDetail.article.type !== ArticleTypeExternal.AUTOMOBILE) return <></>;
  const autoDetails = itemDetail.article;
  return (
    <>
      <DialogHeader
        articleType={ArticleTypeExternal.AUTOMOBILE}
        articleDetailId={itemDetail.id}
        total={{ value: itemDetail.totalPriceWithTax, currency }}
      />
      {itemStatus && (
        <Box pb={2}>
          <StatusTag type={itemStatus.statusColor} labelTextId={itemStatus.status} />
        </Box>
      )}
      <Box paddingY={2} display={'flex'} flexDirection={'column'}>
        <Font variant={'body1'} color={'title'}>
          <Text strong tId={'SUMMARY'} />
        </Font>
        <Box pt={2}>
          <ReadOnlyDataRow labelTextId={'PRODUCT'} value={itemDetail.article.name} underlined />
          {itemDetail.article.reference && (
            <ReadOnlyDataRow labelTextId={'REFERENCE'} value={itemDetail.article.reference} underlined />
          )}
          <ReadOnlyDataRow labelTextId={'UNITS'} value={`${itemDetail.units} x`} underlined />
          <ReadOnlyDataRow
            labelTextId={'UNIT_PRICE_WITH_TAX'}
            value={`${formatMoney({ value: itemDetail.article.unitPriceWithTax, currency })} `}
            underlined
          />
        </Box>
      </Box>
      {autoDetails && (
        <Box paddingY={2}>
          <Font variant={'body1'} color={'title'}>
            <Text strong tId={'DETAILS'} />
          </Font>
          <Box pt={2}>
            <ReadOnlyDataRow labelTextId={'BRAND'} value={autoDetails.brand} underlined />
            <ReadOnlyDataRow labelTextId={'MODEL'} value={autoDetails.model} underlined />
            <ReadOnlyDataRow labelTextId={'VERSION'} value={autoDetails.model} underlined />
            <ReadOnlyDataRow
              labelTextId={'IS_NEW_VEHICLE'}
              value={autoDetails.isNewVehicle ? <Text tId={'YES'} /> : <Text tId={'NO'} />}
              underlined
            />
            <ReadOnlyDataRow labelTextId={'ODOMETER'} value={autoDetails.usage?.odometer} underlined />
            <ReadOnlyDataRow labelTextId={'BODY_TYPE'} value={<Text tId={autoDetails.specs?.bodyType} />} underlined />
            <ReadOnlyDataRow labelTextId={'FUEL_TYPE'} value={<Text tId={autoDetails.specs?.fuelType} />} underlined />
            <ReadOnlyDataRow labelTextId={'GEAR_TYPE'} value={<Text tId={autoDetails.specs?.gear} />} underlined />
            <ReadOnlyDataRow
              labelTextId={'MAX_POWER'}
              value={`${autoDetails.specs?.power} ${getTextIdTranslation('CV')}`}
              underlined
            />
            <ReadOnlyDataRow
              labelTextId={'IMPORTED'}
              value={
                autoDetails.specs?.imported
                  ? (getTextIdTranslation('YES') as string)
                  : (getTextIdTranslation('NO') as string)
              }
              underlined
            />
            <ReadOnlyDataRow
              labelTextId={'REGISTRATION_DATE'}
              value={
                <Text
                  tId={
                    autoDetails.specs?.registrationDate ? formatDateReadable(autoDetails.specs?.registrationDate) : '-'
                  }
                />
              }
              underlined
            />
            <ReadOnlyDataRow
              labelTextId={'DELIVERY_DATE'}
              value={autoDetails.deliveryDate ? formatDateReadable(autoDetails.deliveryDate) : undefined}
              underlined
            />
          </Box>
        </Box>
      )}
    </>
  );
};
